

<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
 
  <div class="carousel-inner">
    <div class="carousel__snapper">
      <div class="carousel_inside" (mouseleave)= "carrosselInicia()" (mouseenter)="carrosselPara()" 
      [@troca] = "muda?'aparece':'some'">
        <app-alert-box [alertData]="alerta"  [icon]="false"></app-alert-box>
        
      </div>
      <aside class="carousel__navigation">
        <ol class="carousel__navigation-list">
          <ng-container *ngFor="let item of userAlerts; let i = index">
            <li class="carousel__navigation-item">
              <input type="radio" [id]="'slide'+i" name="slide" [checked] = "ativo(i)" (click) = "vai(i)">
              <label [for]="'slide'+i" ></label>
            </li>
          </ng-container>
        </ol>
      </aside>
  </div>
  <a class="carousel-control-prev"  role="button" data-slide="prev" (click) = "anterior()">
    <app-lucide-icon class="carousel-control-icon" [iconName]="'chevron-left'" [size]="32"></app-lucide-icon>
    <span class="sr-only">Anterior</span>
  </a>
  <a class="carousel-control-next"  role="button" data-slide="next" (click) = "proximo()">
    <app-lucide-icon class="carousel-control-icon" [iconName]="'chevron-right'" [size]="32"></app-lucide-icon>
    <span class="sr-only">Próximo</span>
  </a>
</div>
